import { isSelfHostedDistribution } from "utils/distribution";

import useSelfHostedFlags from "./useSelfHostedFlags";
import useTypedFlags from "./useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

/**
 * Whether the Flows integration is enabled for the current account; gate every Flows surface
 * (switcher, settings, …) on this.
 * SaaS reads the flag from LaunchDarkly, self-hosted from the backend evaluated flags.
 */
const useIsFlowsIntegrationEnabled = (): boolean => {
  const { flowsIntegration } = useTypedFlags();
  const { flowsIntegration: flowsIntegrationSelfHosted } = useSelfHostedFlags();

  return isSelfHosted ? flowsIntegrationSelfHosted : flowsIntegration;
};

export default useIsFlowsIntegrationEnabled;
